<template>
  <!-- 这个组件的作用是 设置一个基于Vant-Cell 结合 Popup的选择器
  回调选择好的值给调用方，并且自动展示已经选择的内容
  设置title，popup list 对象,结构是 {name, value}, 回调change
  必须支持双向选择，因为还得支持编辑，意味着得支持初始化
  
   -->
  <van-cell
    :title="title"
    :is-link="!readonly"
    :value="displayValue"
    @click.prevent="popupshow = !readonly"
    :label="label"
    :border="border"
  >
    <template v-slot:extra>
      <van-popup
        v-model="popupshow"
        position="bottom"
        get-container=".page-wrap"
      >
        <van-picker
          :columns="columns"
          show-toolbar
          @confirm="onConfirm"
          @cancel="popupshow = false"
          :default-index="defaultIndex"
        />
      </van-popup>
    </template>

  </van-cell>

</template>

<script>
import {
  Cell,
  NavBar,
  Button,
  Row,
  Col,
  Field,
  CellGroup,
  Toast,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Popup,
  Picker
} from "vant";
import _ from "lodash";
import Vue from "vue";
Vue.use(Popup);

export default {
  name: "sby-dropdown",
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Col.name]: Col,
    [Row.name]: Row
  },
  // 自定义组件的值 传递 https://cn.vuejs.org/v2/guide/components-custom-events.html
  props: {
    value: "",
    title: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    label: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    defaultDisplayName: {
      type: String,
      default: ""
    },
    border: {
      type: Boolean,
      default: true 
    },
    column1: {
      type: Array,
      default: null
    },
    valuechanged: Function
  },
  model: {
    event: "change"
  },
  computed: {
    columns() {
      if (!this.column1) {
        return this.list.map(n => n.name);
      }
      return [
        { values: this.column1, className: "column1", defaultIndex: 0 },
        {
          values: this.list.map(n => n.name),
          className: "column2",
          defaultIndex: 0
        }
      ];
    }
  },
  data() {
    return {
      popupshow: false,
      displayValue: "",
      defaultIndex: 0,
      inited: this.value
    };
  },
  mounted() {
    // 从父容器获取 初始化的值
    if (this.defaultDisplayName) {
      this.displayValue = this.defaultDisplayName;
    }
    if (this.inited) {
      this.onValueChanged(this.inited);
    }
  },
  watch: {
    // 监控从父容器 修改方法
    value(newVal) {
      this.onValueChanged(newVal);
    }
  },
  methods: {
    onConfirm(display, indexs) {
      this.doChange(display, indexs);
      let index = this.column1 ? indexs[1] : indexs;
      let value = this.list[index].value;
      this.$emit("valuechanged", value, index);
    },
    doChange(display, indexs) {
      let index = this.column1 ? indexs[1] : indexs;
      this.displayValue = display.join ? display.join(',') : display;
      this.defaultIndex = index;
      let value = this.list[index].value;
      this.$emit("change", value, index);
      this.popupshow = false;
     },
    onValueChanged(newVal) {
      if (!newVal) {
        return;
      }
      let idx = _.findIndex(this.list, n => newVal === n.value);

      if (idx > -1) {
        let initItem = this.list[idx];
        // this.defaultIndex = idx;
        if (initItem) {
          let value = initItem.name;
          if (this.column1) {
            idx = [0, idx];
            value = [this.column1[0], initItem.name];
          }
          this.doChange(value, idx);
        }
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/sby-dropdown.vue